var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "nav notification",
      class: _vm.itemsVisible && "is-open",
      attrs: { id: "headerNotifications" }
    },
    [
      _c("VueNotificationBell", {
        attrs: {
          counter: _vm.activeCount,
          hasDisplayLimit: true,
          isOpen: _vm.itemsVisible
        },
        on: { bellClicked: _vm.toggleShowItemsWrapper }
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.itemsVisible && !_vm.notificationModalVisible,
              expression: "itemsVisible && !notificationModalVisible"
            }
          ],
          staticClass: "notification__list"
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.loadingItems,
                  expression: "loadingItems"
                }
              ],
              staticClass: "notification__loading"
            },
            [_vm._m(0)]
          ),
          _c("h3", { staticClass: "notification__header" }, [
            _vm._v(" Manage Notifications ")
          ]),
          _c("Tabs", {
            attrs: {
              tabs: _vm.tabs,
              selectedTabIndex: _vm.selectedTab,
              contentMaxHeight: "586px",
              variant: "highlight1"
            },
            scopedSlots: _vm._u([
              {
                key: "headerItem1",
                fn: function() {
                  return [_vm._v("Active (" + _vm._s(_vm.activeCount) + ")")]
                },
                proxy: true
              },
              {
                key: "headerItem2",
                fn: function() {
                  return [
                    _vm._v(" Dismissed (" + _vm._s(_vm.dismissedCount) + ") ")
                  ]
                },
                proxy: true
              },
              {
                key: "1",
                fn: function() {
                  return [
                    _vm.activeNotificationItems.length === 0
                      ? _c("VueNotificationEmptyListMessage", {
                          attrs: {
                            labelText: "You have no active notifications."
                          }
                        })
                      : _vm._e(),
                    _vm.activeNotificationItems.length > 0
                      ? _c("InfiniteScroller", {
                          staticClass: "notification__infinity-scroll",
                          attrs: {
                            loading: _vm.activeLoading,
                            hasMoreResults: _vm.hasMoreActiveResults
                          },
                          on: { scrollBoundary: _vm.onScrollBoundaryActive },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "scrollDiv",
                                fn: function() {
                                  return [
                                    _c("VueNotificationList", {
                                      attrs: {
                                        items: _vm.activeNotificationItems
                                      },
                                      on: {
                                        notificationClick:
                                          _vm.onNotificationClick,
                                        dismissClick:
                                          _vm.onNotificationDismissed,
                                        saveClick: _vm.onNotificationDismissed
                                      }
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            2536609579
                          )
                        })
                      : _vm._e()
                  ]
                },
                proxy: true
              },
              {
                key: "2",
                fn: function() {
                  return [
                    _vm.dismissedNotificationItems.length === 0
                      ? _c("VueNotificationEmptyListMessage", {
                          attrs: {
                            labelText: "You have no dismissed notifications."
                          }
                        })
                      : _vm._e(),
                    _vm.dismissedNotificationItems.length > 0
                      ? _c("InfiniteScroller", {
                          staticClass: "notification__infinity-scroll",
                          attrs: {
                            loading: _vm.dismissedLoading,
                            hasMoreResults: _vm.hasMoreDismissedResults
                          },
                          on: { scrollBoundary: _vm.onScrollBoundaryDismissed },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "scrollDiv",
                                fn: function() {
                                  return [
                                    _c("VueNotificationList", {
                                      attrs: {
                                        items: _vm.dismissedNotificationItems
                                      },
                                      on: {
                                        notificationClick:
                                          _vm.onNotificationClick
                                      }
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            1469055079
                          )
                        })
                      : _vm._e()
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _vm.notificationModalVisible
        ? _c("IframeContainer", { attrs: { source: _vm.iframeSource } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("i", { staticClass: "icon icon-loading" }, [
      _c("span", { staticClass: "path1" }),
      _c("span", { staticClass: "path2" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }